import React, { useCallback } from 'react';
import { taskBoardActions } from '../../../../store/slices/taskBoardSlice/taskBoardSlice';
import { useAppDispatch } from '../../../../store';
import cls from './emptyTasksBlurContainer.module.css';
import { useTranslation } from 'react-i18next';

export const EmptyTasksBlurContainer = () => {
    const dispatch = useAppDispatch();
    const onClickOpenCreateTask = useCallback(() => {
        dispatch(taskBoardActions.onModalMode('addNewTask'));
    }, []);

    const { t } = useTranslation();
    return (
        <div className={cls.EmptyTasksBlurContainer} onClick={onClickOpenCreateTask}>
            <span className={cls.EmptyTasks_add}>
                <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g clipPath="url(#clip0_3545_16253)">
                        <path
                            d="M12 5H24V3H12V5ZM12 13H24V11H12V13ZM12 21H24V19H12V21Z"
                            fill="#818998"
                        />
                        <path
                            d="M5.25 5.25V1.5H3.75V5.25H0V6.75H3.75V10.5H5.25V6.75H9V5.25H5.25Z"
                            fill="#818998"
                        />
                    </g>
                    <defs>
                        <clipPath id="clip0_3545_16253">
                            <rect width="24" height="24" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
            </span>
            <span className={cls.EmptyTasks_text}>
                {t('EmptyTasksBlurContainer.return.EmptyTasks_text')}
            </span>
        </div>
    );
};
